import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { UserNotificationService } from 'src/app/services/notofications/user-notification.service';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { TournamentService } from 'src/app/services/tournaments/tournament.service';
import { environment } from 'src/environments/environment';
import { BasePageComponent } from '../../base-page/base-page.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { Tournament } from 'src/app/services/tournaments/tournaments.models';
import { MissionService } from 'src/app/services/missions/mission.service';
import { Mission } from 'src/app/services/missions/missions.models';

@Component({
  selector: 'app-tournamnent-ingame-info',
  templateUrl: './tournamnent-ingame-info.component.html',
  styleUrls: ['./tournamnent-ingame-info.component.scss']
})
export class TournamnentIngameInfoComponent extends BasePageComponent {

  constructor(
    private tournamentService: TournamentService,
    private missionsService: MissionService,
    private tournamentDetailsService: TournamentDetailsService,
    private userNotificationService: UserNotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceDetectService: DeviceDetectorService,
    protected licenceService: LicenceService
  ) { super() }

  private _gameId: string;

  @Input() set gameIdValue(value: string) {
    this._gameId = value;
    if (!!this._gameId) {
      const resp = this.tournamentService.getActiveTournamentForGameId(this._gameId).pipe(
        filter(resp => resp.tournamentIndes > -1),
        takeUntil(this.unsubscribe)
      ).subscribe((resp) => {
        this.tournamentIndex = resp.tournamentIndes;
        this.tournamentRef = resp.tournamentRef;
        const tournament = resp.tournament as Tournament;
        this.tournamentId = tournament?.cmsId;
        this.userNotificationService.notify("tournamentNotification", { bet: `${tournament.minBet} ${environment.baseCurrency}` })

        this.tournamentDetailsService.getTournamentRank(this.tournamentRef).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
          this.myPosition = resp.myPosition + 1
        })

      });

    }
  }

  tournamentId: string;
  tournamentIndex: number;
  tournamentRef: string;
  myPosition: number;

  ngOnInit(): void {
    this.isDesktop = this.deviceDetectService.isDesktop();
  }

  openTournamentDialog(): void {
    this.router.navigate(['tournaments', 'id', this.tournamentId], { relativeTo: this.route, skipLocationChange: true });
  }

}